const StatusComponent = ({ status }: { status: string }) => {
    const getStatusStyle = () => {
        switch (status) {
            case "inProgress":
                return "bg-[#EFD5B7] text-[#181818] font-medium rounded-[6px] px-4 py-1 text-body-sm inline-block";
            case "done":
                return "bg-[#ACEECD] text-[#181818] font-medium rounded-[6px] px-4 py-1 text-body-sm inline-block";
            case "failed":
                return "bg-[#690B0B] text-[#F6F6F6] font-medium rounded-[6px] px-4 py-1 text-body-sm inline-block";
            case "refund":
                return "bg-gray-200 text-gray-800 font-medium rounded-[6px] px-4 py-1 text-body-sm inline-block";
            default:
                return "";
        }
    };

    const getStatusText = () => {
        switch (status) {
            case "inProgress":
                return "Pending";
            case "done":
                return "Successful";
            case "failed":
                return "Failed";
            case "refund":
                return "Refund";
            default:
                return "";
        }
    };

    return (
        <div className={getStatusStyle()}>
            {getStatusText()}
        </div>
    );
}

export default StatusComponent;